<template>
    <div class="reo-dialog dialog">
        <div class="reo-dialog-inner">
            <slot name="top"></slot>
            <p class="dialog-title" v-if="title">{{ title }}</p>
            <p class="dialog-des" v-if="description">{{ description }}</p>
            <p class="support-tip" v-if="supportTip">{{ supportTip }}</p>
            <ul class="des-list" v-if="supportList">
                <li v-for="(item, index) in supportList" :key="index">
                    <p class="des-title">{{ item.title }}</p>
                    <p class="des-content">{{ item.content }}</p>
                </li>
            </ul>
            <slot></slot>
            <button v-if="showButton && labelOfConfirm" @click="confirm" class="ui-button primary-button short-button">{{ labelOfConfirm || $t( 'dialog.yes' ) }}</button>
            <button v-if="showButton && labelOfCancel" @click="cancel" class="ui-button empty-button short-button">{{ labelOfCancel || $t( 'dialog.no' ) }}</button>
            <span
            @click="cancel"
            class="close icon-cross2"></span>
        </div>
    </div>
</template>

<script>
export default {

    props: {

        title: String,
        description: String,
        labelOfConfirm: String,
        labelOfCancel: String,
        showButton: {
            type: Boolean,
            default: true
        },
        supportTip: String,
        supportList: Array

    },

    methods: {

        confirm () {

            this.$emit( 'confirm' );

        },

        cancel () {

            this.$emit( 'cancel' );

        }

    }

};

</script>

<style lang="less" scoped>

    .dialog.reo-dialog{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, .6);
        z-index: 8;
        
        .reo-dialog-inner{
            padding: 0.6rem 0.4rem;
            box-sizing: border-box;
            text-align: center;
            transform: translate(-50%,-50%);
            top: 50%;
            left: 50%;
            background-color: #fff;
            border-radius: .2rem;
            position: fixed;
            max-width: 690px;

            .support-tip {
                text-align: left;
                font-size: .18rem;
                margin-bottom: .2rem;

                @media screen and ( max-width: 1199px ) {
                    font-size: .24rem;
                }
            }

            .des-list {
                text-align: left;
                font-size: .18rem;
                margin-bottom: .4rem;

                li + li {
                    margin-top: .2rem;
                }
                .des-title {
                    font-weight: 500;
                }

                @media screen and ( max-width: 1199px ) {
                    font-size: .24rem;
                }
            }
            
            .close{
                font-size: 0.26rem;
                position: absolute;
                top: 0.1rem;
                right: 0.1rem;
                cursor: pointer;
            }
        }
    }

    @media screen and (max-width: 680px) {
        .dialog .reo-dialog-inner{
            left: 15px;
            right: 15px;
            transform: translate(0px, -50%);
        }
    }

    .dialog .reo-dialog-inner p.dialog-title{

        color: #333;
        font-weight: 500;
        font-size: .3rem;
        margin-bottom: .4rem;

    }

    .dialog .reo-dialog-inner p.dialog-des{
        font-size: 0.18rem;
        margin-bottom: 0.4rem;
    }

    .dialog .reo-dialog-inner button+button{
        margin-left: 0.2rem;
    }

    @media screen and ( max-width: 1199px ) {
        .dialog .reo-dialog-inner{
            max-width: 100%;
            padding: 0.6rem 0.3rem;
            width: 6.9rem;
        }
        .dialog .reo-dialog-inner p.dialog-des{
            font-size: 0.24rem;
        }

        .dialog .reo-dialog-inner p.dialog-title{
            font-size: 0.4rem;
        }

        .reo-dialog-inner .ui-button{
            font-size: 0.24rem;
            width: 100%;
        }

        .dialog .reo-dialog-inner button+button{
            margin: 0.3rem 0 0 0;
        }

    }

</style>



// WEBPACK FOOTER //
// src/basic/Dialog.vue